import { render, staticRenderFns } from "./SlotCard.vue?vue&type=template&id=f1fd8d7c&scoped=true&"
import script from "./SlotCard.vue?vue&type=script&lang=js&"
export * from "./SlotCard.vue?vue&type=script&lang=js&"
import style0 from "./SlotCard.vue?vue&type=style&index=0&id=f1fd8d7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fd8d7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VCard,VIcon})
